import React from 'react';
import PropTypes from 'prop-types';
import { clone, filter, findIndex, isNil, length, move, propEq, remove } from 'ramda';
import moment from 'moment';
import CheckIcon from '@components/@core/CheckIcon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { inPage } from '~/services/util';

class TrainingsEdit extends React.PureComponent {
    state = { current: 1, per: 5 };

    handlePagination = (e) => {
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.setState({ per: e });
    };

    handleSelectMenu = (item) => (e) => {
        const index = findIndex(propEq('id', item.id), this.props.data);
        let data = clone(this.props.data);
        switch (e) {
            case 'move up':
                data = move(index, index - 1, data);
                break;
            case 'move down':
                data = move(index, index + 1, data);
                break;
            case 'remove':
                data = remove(index, 1, data);
                break;
            default:
                break;
        }
        this.props.onChange(data);
    };

    render() {
        const { current, per } = this.state;
        const { data, type } = this.props;

        return (
            <div className="career-required-instances">
                <div className="trainings">
                    <div className="list desktop-screen">
                        <div className="d-flex-1" />
                        <div className="modules">
                            <span className="dsl-m12">Modules</span>
                        </div>
                        <div className="compl">
                            <span className="dsl-m12">Compl.</span>
                        </div>
                        <div className="due">
                            <span className="dsl-m12">Due</span>
                        </div>
                        <div className="status">
                            <span className="dsl-m12">Status</span>
                        </div>
                        <div className="edit" />
                    </div>
                    {data.map((item, index) => {
                        let dotsMenu = ['Move Down', 'Move Up', 'Remove'];
                        if (index === 0) {
                            dotsMenu = filter((x) => x !== 'Move Up', dotsMenu);
                        }
                        if (length(data) === index + 1) {
                            dotsMenu = filter((x) => x !== 'Move Down', dotsMenu);
                        }

                        return (
                            inPage(index, current, per) && (
                                <div className="list required-tranings" key={`tr-${index}`}>
                                    <div className="d-flex d-flex-1">
                                        <CheckIcon className="my-auto" size={26} checked={!isNil(item.completed_at)} />
                                        <Thumbnail source={item.data.thumb_url || item.thumbnail} size="tiny" />
                                        <div className="ml-4 w-100">
                                            <p className="dsl-b14 text-400 mb-1">{item.data.name || item.title || item.name}</p>
                                            <p className="dsl-m12 mb-0">Assigned: Career</p>
                                        </div>
                                        <div className="edit w-100 mobile-screen">
                                            <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                        </div>
                                    </div>
                                    <div className="modules">
                                        <span className="dsl-m12 w-30 mobile-screen">Modules</span>
                                        <span className="dsl-m12">{item.data.module_count}</span>
                                    </div>
                                    <div className="compl">
                                        <span className="dsl-m12 w-30 mobile-screen">Compl.</span>
                                        <span className="dsl-m12">Na</span>
                                    </div>
                                    <div className="due">
                                        <span className="dsl-m12 w-30 mobile-screen">Due</span>
                                        <span className="dsl-m12">{type === 'template' ? 'Na' : moment(item.due_at).format('MMM DD')}</span>
                                    </div>
                                    <div className="status">
                                        <span className="dsl-m12 w-30 mobile-screen">Status</span>
                                        <span className="dsl-m12">{type === 'template' ? 'Na' : isNil(item.completed_at) ? 'In Progress' : 'Completed'}</span>
                                    </div>

                                    <div className="edit desktop-screen">
                                        <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
                <Pagination current={current} per={per} pers={[5, 10, 'all']} total={Math.ceil(data.length / per)} onChange={this.handlePagination} onPer={this.handlePer} />
            </div>
        );
    }
}

TrainingsEdit.propTypes = {
    data: PropTypes.array,
    type: PropTypes.oneOf(['instance', 'template']),
};

TrainingsEdit.defaultProps = {
    data: [],
    type: 'instance',
};

export default TrainingsEdit;
